import { baseEnvironment } from './environment.base';
export const environment = {
  ...baseEnvironment,
  API_URL: '/stageEnvUrl',
  staging: true,
  enableSummaryReport: true,
  // baseUrl: 'http://127.0.0.1:4001/api',
  baseUrl: 'https://atbr-stage.mpowerpractice.net/api',
  azureClientId: '23de3c76-1724-4860-be70-0700f3a0026e',
  azureTenantId: '2e09f3a3-0520-461f-8474-052a8ed7814a',
  azureRedirectURI: 'net.mpowerpractice.atbr://oauth/redirect',
  apiEndPoints: {
    patientProcedureInformation: {
      surgeries: 'surgeries',
      clinicians: 'clinicians',
      priorSurgeryReports: 'prior-surgery-reports',
      surgery: 'surgery'
    },
    surgeryModalities: {
      modalities: 'surgery-modalities'
    },
    anestheticVitals: {
      vitals: 'anesthetic-vitals',
      anesthetic_vitals_checkboxes_values: 'anesthetic-vitals-checkboxes-values',
      updateVitals: 'anesthetic-vitals-update',
      updateVitalCheckBoxex: 'update-vital-checkboxes'
    },
    surgetyDiagnosis: {
      diagnosis: 'surgery-diagnosis'
    },
    auth: {
      azureSSOLogin: '/auth/azurelogin',
      loginUrl: '/auth/login'
    },
    surgeryInductionAnestheticAgents: {
      induction: '/induction'
    },
    surgeryTimes: {
      surgeryTimes: '/surgerytimes'
    },
    cadwellEvents: {
      cadwellEvents: '/cadwellevents'
    },
    ipChatLogs: {
      ipChatLogs: '/ipchatlogs'
    },
    usmon: {
      usmon: '/usmon'
    },
    printReports: {
      printReports: '/printreport'
    },
    anestheticInfusion: {
      anestheticInfusion: '/anestheticsinfusion'
    },
    surgeryCase: {
      summary: 'surgery-case-summary',
      restrictions: 'surgery-modality-restrictions'
    },
    upperSsep: {
      upperSsep: '/upperssep'
    },
    lowerSsep: {
      lowerSsep: '/lowerssep'
    },
    upperMep: {
      upperMep: '/uppermep'
    },
    lowerMep: {
      lowerMep: '/lowermep'
    },
    upperEmg: {
      upperEmg: '/upperemg'
    },
    lowerEmg: {
      lowerEmg: '/loweremg'
    },
    absAxialEmg: {
      absAxialEmg: '/absaxialemg'
    },
    craniEmg: {
      craniEmg: '/craniemg'
    },
    anal: {
      anal: '/analsphincteremg'
    },
    urethral: {
      urethral: '/urethralsphincteremg'
    },
    baep: {
      baep: '/baepemg'
    },
    vep: {
      vep: '/vepemg'
    },
    snap: {
      snap: '/snapemg'
    },
    hreflex: {
      hreflex: '/hreflexemg'
    },
    mapping: {
      mapping: '/mappingemg'
    },
    dssep: {
      dssep: '/dssepemg'
    },
    eeg: {
      eeg: '/eeg'
    },
    lateralApproach: {
      lateralApproach: '/lateralapproachemg'
    },
    triggreedEmg: {
      triggreedEmg: '/triggeereedemg'
    },
    thresholdTable: {
      thresholdTable: '/thresholdtable'
    },
    thresholdTableInsert: {
      thresholdTableInsert: '/thresholdtableinsert'
    },
    thresholdTableUpdate: {
      thresholdTableUpdate: '/threshold-update'
    },
    leftAlert: {
      leftAlert: '/insert-threshold-table-left-alert'
    },
    rihtAlert: {
      rightAlert: '/insert-threshold-table-right-alert'
    },
    getLeftAlert: {
      getLeftAlert: '/get-threshold-table-left-alert'
    },
    updateLeftAlert: {
      updateLeftAlert: '/update-threshold-left-alert'
    },
    getRightAlert: {
      getRightAlert: '/get-threshold-table-right-alert'
    },
    updateRightAlert: {
      updateRightAlert: '/update-threshold-right-alert'
    },
    additionalAlertIssuedGet: {
      additionalAlertIssuedGet: '/get-additional-alert-issued'
    },
    userLogoutUrl: {
      userLogoutUrl: '/user_logout'
    },
    users: {
      all: '/user/all',
      users: '/users',
      usersAudit: '/users/audit'
    },
    additionalAlertIssueInsert: {
      additionalAlertIssueInsert: '/insert-additional-alert-issued'
    },
    additionalAlertIssueUpdate: {
      additionalAlertIssueUpdate: '/update-additional-alert-issued'
    },
    atbrPdf: {
      atbrPdf: '/atbr-pdf'
    },
    physicians: {
      all: '/physicians/all',
      physician: '/physician'
    },
    followUpCall: {
      followUpCall: '/follow-up-call'
    },
    getsurgeryModalities: {
      modalities: 'get-surgery-modalities'
    },
    updateTo4Modality: {
      updateTo4Modality: '/update-to4modality'
    },
    getTo4Modality: {
      getTo4Modality: '/get-to4modality'
    },
    anestheticInfusionUpdate: {
      anestheticInfusionUpdate: '/anesthetics-infusion-update'
    },
    uncheckAdditionalAlertIssueUpdate: {
      uncheckAdditionalAlertIssueUpdate: '/uncheck-additional-alert-issued'
    },
    deleteThresholdEntry: {
      deleteThresholdEntry: '/delete-threshold-entry'
    },
    textSummarization: {
      caseSummaryReport: 'text-summarization/case-summary',
      saveCaseSummaryReport: 'text-summarization/case-summary/save',
      savedCaseSummaryReport: 'text-summarization/case-summary/saved'
    }
  }
};
